import React from "react";
import "./style.scss";
import MainBanner from "./MainBanner";
import Produccts from "./Products";
import Solutions from "./Solutions";
import Partners from "./Partners";
import Resources from "./Resources";
import Demo from "./Demo";

const Home: React.FC = () => {
  return (
    <div>
      <MainBanner />
      <Produccts />
      <Solutions />
      <Partners />
      <Resources />
      <Demo />
    </div>
  );
};

export default Home;
